var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// AUTO-GENERATED CONTENT - DO NOT MANUALLY EDIT - Run 'yarn generate:icons' to update
import Icon from '../icon-internal';
function Bulb(_a) {
    var { size } = _a, restProps = __rest(_a, ["size"]);
    return (_jsx(Icon, Object.assign({ viewBox: "0 0 18 18", size: size }, restProps, { children: _jsx("path", { fill: "currentColor", d: "M9 0a7 7 0 0 1 4.95 11.95l-.001-.001c-.794.795-.949 1.1-.949 2.051a1 1 0 0 1-2 0c0-1.548.396-2.325 1.535-3.467l.04-.037a5 5 0 1 0-7.11.037C6.605 11.675 7 12.453 7 14a1 1 0 0 1-2 0c0-.951-.155-1.256-.949-2.051A7 7 0 0 1 9 0Zm0 7a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1Zm0 11c-1.657 0-3-.895-3-2h6c0 1.105-1.343 2-3 2Z" }) })));
}
export default Bulb;
